import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid2,
  Chip,
  Icon,
  Avatar,
  Paper,
  useTheme,
} from '@mui/material';

const HeroHome = () => {
  const theme = useTheme();

  const handleDescargar = () => {
    window.open('https://play.google.com/store/apps/details?id=com.rauhtech.rauhapp&pcampaignid=web_share', '_blank');
  };

  const handleVerMas = () => {
    const el = document.getElementById('que-es');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        background:
          theme.palette.mode === 'dark'
            ? 'linear-gradient(145deg, #1e293b 0%, #0f172a 50%, #020617 100%)'
            : 'linear-gradient(145deg, #1c215e 0%, #2d3484 50%, #1e2258 100%)',
        color: 'white',
        pt: { xs: 12, md: 16 },
        pb: { xs: 8, md: 12 },
      }}
    >
      {/* Círculos decorativos orgánicos estilo rauh-rifas */}
      <Box
        className="animate-orb"
        sx={{
          position: 'absolute',
          width: { xs: 260, md: 450 },
          height: { xs: 260, md: 450 },
          borderRadius: '50%',
          backgroundColor: 'rgba(255, 255, 255, 0.04)',
          top: -100,
          right: -80,
          pointerEvents: 'none',
        }}
      />
      <Box
        className="animate-orb"
        sx={{
          position: 'absolute',
          width: { xs: 180, md: 320 },
          height: { xs: 180, md: 320 },
          borderRadius: '50%',
          backgroundColor: 'rgba(241, 91, 40, 0.18)',
          bottom: -60,
          left: '10%',
          pointerEvents: 'none',
          filter: 'blur(30px)',
          animationDelay: '-3s',
        }}
      />
      <Box
        className="animate-orb"
        sx={{
          position: 'absolute',
          width: 140,
          height: 140,
          borderRadius: '50%',
          backgroundColor: 'rgba(16, 185, 129, 0.12)',
          top: '30%',
          left: '45%',
          pointerEvents: 'none',
          filter: 'blur(25px)',
          animationDelay: '-6s',
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid2 container spacing={{ xs: 4, md: 6 }} alignItems="center">
          {/* Columna Izquierda: Mensaje Principal */}
          <Grid2 size={{ xs: 12, md: 7 }} className="animate-fade-in-up">
            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, px: 2, py: 0.8, bgcolor: 'rgba(255,255,255,0.12)', backdropFilter: 'blur(8px)', borderRadius: '6px', mb: 3, border: '1px solid rgba(255,255,255,0.15)' }}>
              <Icon sx={{ color: theme.palette.secondary.main, fontSize: 20 }}>local_fire_department</Icon>
              <Typography variant="caption" sx={{ fontWeight: 800, textTransform: 'uppercase', letterSpacing: 0.8, color: '#ffffff' }}>
                La Plataforma Oficial para gestionar tus Rifas
              </Typography>
            </Box>

            <Typography
              variant="h1"
              sx={{
                fontWeight: 900,
                fontSize: { xs: '2.2rem', sm: '3rem', md: '3.6rem' },
                lineHeight: 1.15,
                letterSpacing: '-0.03em',
                mb: 2.5,
                color: '#ffffff',
              }}
            >
              Crea, Administra y Vende tus{' '}
              <Box
                component="span"
                sx={{
                  background: 'linear-gradient(135deg, #f15b28 0%, #ff8a65 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  color: 'transparent',
                }}
              >
                Rifas en Vivo
              </Box>
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.85)',
                fontSize: { xs: '1rem', md: '1.18rem' },
                lineHeight: 1.65,
                mb: 4,
                maxWidth: 560,
              }}
            >
              Crea rifas profesionales, personaliza tu tablero interactivo con números de 2, 3 o 4 cifras y comparte tu enlace público para que tus clientes elijan y reserven sus boletos favoritos en tiempo real.
            </Typography>

            {/* Acciones principales con micro-animaciones */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 5 }}>
              <Button
                variant="contained"
                size="large"
                href="#descargar"
                sx={{
                  bgcolor: theme.palette.secondary.main,
                  color: 'white',
                  px: 4,
                  py: 1.6,
                  fontSize: '1.05rem',
                  fontWeight: 900,
                  borderRadius: '10px',
                  boxShadow: '0 8px 24px rgba(241, 91, 40, 0.4)',
                  transition: 'all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)',
                  '&:hover': {
                    bgcolor: '#d94c1c',
                    transform: 'translateY(-3px)',
                    boxShadow: '0 12px 28px rgba(241, 91, 40, 0.5)',
                  },
                }}
              >
                Descargar la App Gratis
              </Button>
              <Button
                variant="outlined"
                size="large"
                href="#funciones"
                sx={{
                  color: 'white',
                  borderColor: 'rgba(255, 255, 255, 0.4)',
                  px: 3.5,
                  py: 1.6,
                  fontSize: '1.02rem',
                  fontWeight: 800,
                  borderRadius: '10px',
                  backdropFilter: 'blur(6px)',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  transition: 'all 0.25s ease',
                  '&:hover': {
                    borderColor: '#ffffff',
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                    transform: 'translateY(-3px)',
                  },
                }}
              >
                Explorar Funciones
              </Button>
            </Box>

            {/* Badges de Confianza con sutil hover */}
            <Box sx={{ display: 'flex', gap: 3.5, flexWrap: 'wrap', pt: 1, borderTop: '1px solid rgba(255,255,255,0.12)' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Icon sx={{ color: '#38bdf8', fontSize: 18 }}>verified_user</Icon>
                <Typography variant="caption" sx={{ fontWeight: 700, color: 'rgba(255,255,255,0.9)' }}>
                  100% Seguro y Transparente
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Icon sx={{ color: '#38bdf8', fontSize: 18 }}>sync</Icon>
                <Typography variant="caption" sx={{ fontWeight: 700, color: 'rgba(255,255,255,0.9)' }}>
                  Sincronización en Tiempo Real
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Icon sx={{ color: '#38bdf8', fontSize: 18 }}>qr_code_2</Icon>
                <Typography variant="caption" sx={{ fontWeight: 700, color: 'rgba(255,255,255,0.9)' }}>
                  Enlaces Cortos y Códigos QR
                </Typography>
              </Box>
            </Box>
          </Grid2>

          {/* Columna Derecha: Tarjeta / Mockup Visual con Animación Flotante */}
          <Grid2 size={{ xs: 12, md: 5 }}>
            <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
              <Paper
                elevation={3}
                className="animate-float"
                sx={{
                  borderRadius: '16px',
                  overflow: 'hidden',
                  bgcolor: theme.palette.mode === 'dark' ? '#131b2e' : '#ffffff',
                  color: theme.palette.text.primary,
                  p: 2.8,
                  maxWidth: 420,
                  width: '100%',
                  boxShadow: theme.palette.mode === 'dark' ? '0 24px 60px rgba(0,0,0,0.6)' : '0 24px 60px rgba(0,0,0,0.25)',
                  border: theme.palette.mode === 'dark' ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(255,255,255,0.2)',
                  position: 'relative',
                  zIndex: 2,
                  transition: 'box-shadow 0.3s ease',
                  '&:hover': {
                    boxShadow: theme.palette.mode === 'dark' ? '0 30px 70px rgba(0,0,0,0.7)' : '0 30px 70px rgba(45,52,132,0.3)',
                  },
                }}
              >
                {/* Cabecera de la Rifa Mockup */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.4 }}>
                    <Avatar sx={{ bgcolor: theme.palette.primary.main, color: 'white', width: 42, height: 42, borderRadius: '8px' }}>
                      <Icon sx={{ fontSize: 24 }}>confirmation_number</Icon>
                    </Avatar>
                    <Box>
                      <Typography variant="subtitle2" sx={{ fontWeight: 800, lineHeight: 1.2, color: theme.palette.text.primary, fontSize: '0.92rem' }}>
                        Gran Rifa Pro Fondos
                      </Typography>
                      <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontWeight: 500 }}>
                        Sorteo Oficial • 8:00 PM
                      </Typography>
                    </Box>
                  </Box>
                  <Chip
                    icon={<Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#10b981', ml: 1, animation: 'pulseGlow 1.8s infinite' }} />}
                    label="En Vivo"
                    size="small"
                    sx={{
                      bgcolor: 'rgba(16, 185, 129, 0.15)',
                      color: '#10b981',
                      fontWeight: 800,
                      borderRadius: '6px',
                    }}
                  />
                </Box>

                {/* Premio Card con sutil brillo */}
                <Box sx={{ p: 1.8, bgcolor: 'rgba(241, 91, 40, 0.08)', borderRadius: '10px', border: '1px solid rgba(241, 91, 40, 0.25)', mb: 2, display: 'flex', alignItems: 'center', gap: 1.6, transition: 'all 0.2s ease', '&:hover': { transform: 'scale(1.02)' } }}>
                  <Icon sx={{ color: theme.palette.secondary.main, fontSize: 34 }}>emoji_events</Icon>
                  <Box>
                    <Typography variant="caption" sx={{ color: theme.palette.secondary.main, fontWeight: 800, textTransform: 'uppercase', fontSize: '0.72rem' }}>
                      Premio Mayor
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 900, color: theme.palette.text.primary, fontSize: '0.92rem' }}>
                      iPhone 17 Pro Max 256GB
                    </Typography>
                  </Box>
                </Box>

                {/* Mini Tablero Interactivo */}
                <Typography variant="caption" sx={{ fontWeight: 800, color: theme.palette.text.secondary, mb: 1, display: 'block', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  Tablero de Boletos en Tiempo Real
                </Typography>

                <Grid2 container spacing={0.6} sx={{ mb: 2 }}>
                  {['00', '01', '02', '03', '04', '05', '06', '07', '08', '09'].map((num, i) => {
                    const isReserved = i === 2 || i === 7;
                    const isPaid = i === 4;
                    const isSelected = i === 1 || i === 8;
                    let bg = theme.palette.mode === 'dark' ? '#1e293b' : '#2d3484';
                    let color = '#ffffff';
                    let label = num;

                    if (isSelected) {
                      bg = '#f15b28';
                    } else if (isReserved) {
                      bg = '#334155';
                      label = '🔒';
                    } else if (isPaid) {
                      bg = '#10b981';
                      label = '⭐';
                    }

                    return (
                      <Grid2 key={num} size={2.4}>
                        <Box
                          sx={{
                            aspectRatio: '1 / 1',
                            bgcolor: bg,
                            color: color,
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 800,
                            fontSize: (isReserved || isPaid) ? '1.25rem' : '0.85rem',
                            cursor: 'pointer',
                            transition: 'all 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)',
                            boxShadow: isSelected ? '0 3px 10px rgba(241,91,40,0.35)' : 'none',
                            '&:hover': {
                              transform: 'scale(1.1)',
                              zIndex: 3,
                            },
                          }}
                        >
                          {label}
                        </Box>
                      </Grid2>
                    );
                  })}
                </Grid2>

                {/* Botón Mockup con micro-interacción */}
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    bgcolor: theme.palette.mode === 'dark' ? '#434bbd' : theme.palette.primary.main,
                    py: 1.2,
                    fontWeight: 800,
                    borderRadius: '8px',
                    boxShadow: 'none',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.02)',
                    },
                  }}
                >
                  ⚡ Reservar 2 Boletos ($20.000)
                </Button>
              </Paper>
            </Box>
          </Grid2>
        </Grid2>
      </Container>
    </Box>
  );
};

export default HeroHome;
